<template>
  <div class="mb-4">
    <div>
      <v-row class="mx-0" justify="center" align="center">
        <v-text-field
          id="Stats_obj_search"
          :label="$tc('object_stats_btn_name')"
          outlined
          single-line
          clearable
          v-model="objectId"
          @click:clear="clearView()"
          :error-messages="objectErrors"
          @input="$v.objectId.$touch()"
          @blur="$v.objectId.$touch()"
          @keydown.delete="deleteKeyPressed"
        />

        <v-col class="mb-8" cols="2">
          <v-select
            hide-details=""
            height="55"
            :items="refreshIntervalOptions"
            item-text="name"
            :label="$t('scale')"
            v-model="duration"
            outlined
          />
        </v-col>

        <v-btn
          v-if="!isStarted"
          id="Stats_obj_btn_start"
          class="mb-8"
          height="55"
          color="secondary"
          :disabled="$v.$invalid"
          :dark="!$v.$invalid"
          @click="execute()"
        >
          <v-icon>
            play_arrow
          </v-icon>
        </v-btn>

        <v-btn
          v-else
          id="Stats_obj_btn_stop"
          class="mb-8"
          height="55"
          color="secondary"
          :disabled="$v.$invalid"
          :dark="!$v.$invalid"
          @click="handlePause()"
        >
          <v-icon>
            pause
          </v-icon>
        </v-btn>
      </v-row>
    </div>

    <div v-if="!loading">
      <v-card outlined class="rounded-lg mb-4">
        <v-card-text>
          <v-row no-gutters justify="center" align="center">
            <v-col class="text-center" cols="12" sm="4">
              <div id="object_stats_start_t" class="mb-1 my-sm-0">
                {{ `${$t("object_stats_start_t")}:` }} {{ `${$getDateString({ date: wctTransaction, timeDetailLevel: 2 }) || '--/--/----'}` }}
              </div>
            </v-col>

            <v-divider v-if="$vuetify.breakpoint.smAndUp" vertical />

            <v-col class="text-center" cols="12" sm="4">
              <div id="object_stats_last_t" class="mb-1 my-sm-0">
                {{ `${$t("object_stats_last_t")}: ` }} {{ `${$getDateString({ date: dateLastTransaction, timeDetailLevel: 2 }) || '--/--/----'}` }}
              </div>
            </v-col>

            <v-divider v-if="$vuetify.breakpoint.smAndUp" vertical />

            <v-col class="text-center" cols="12" sm="4">
              <div class="mb-1 my-sm-0">
                {{ `${$t("object_count")}: ${countTransaction}` }}
              </div>
            </v-col>

            <!-- <v-divider v-if="$vuetify.breakpoint.smAndUp" vertical />

            <v-col class="text-center" cols="12" sm="3">
              {{ `${$t("now")}: ` }}  {{ `${$getDateString({ date: date, timeDetailLevel: 2 }) || '--/--/----'}` }}
            </v-col> -->
          </v-row>
        </v-card-text>
      </v-card>

      <v-row>
        <!-- COUNT TRANSACTION -->
        <v-col :cols="cardColunmWidth">
          <v-card outlined class="rounded-lg" height="370">
            <v-card-title class="text-subtitle-1 font-weight-bold">
              {{ $t("object_count") }}
            </v-card-title>

            <v-card-text>
              <count-transaction-chart
                :is-started="isStarted"
                :dataset="countTransactionDataset"
                :scala="duration"
              />
            </v-card-text>
          </v-card>
        </v-col>

        <!-- RATE TRANSACTION -->
        <v-col :cols="cardColunmWidth">
          <v-card outlined class="rounded-lg" height="370">
            <v-card-title class="text-subtitle-1 font-weight-bold">
              {{ $t("object_rate_t") }}
            </v-card-title>

            <v-card-text>
              <rate-transaction-chart
                :is-started="isStarted"
                :dataset="rateTransactionDataset"
                :scala="duration"
              />
            </v-card-text>
          </v-card>
        </v-col>

        <!-- TRANSACTION USAGE RATE VARIATION -->
        <v-col :cols="cardColunmWidth">
          <v-card outlined class="rounded-lg" height="370">
            <v-card-title class="text-subtitle-1 font-weight-bold">
              {{ $t("object_variation_rate_t") }}
            </v-card-title>

            <v-card-text>
              <transaction-usage-rate-variation
                :is-started="isStarted"
                :dataset="transactionUsageRateVariation"
                :scala="duration"
              />
            </v-card-text>
          </v-card>
        </v-col>

        <div ref="elementToScrollTo" />

        <v-col :cols="cardColunmWidth">
          <v-card outlined class="rounded-lg" height="370">
            <v-card-title class="text-subtitle-1 font-weight-bold">
              {{ $t("average_usage_last_seconds") }}
            </v-card-title>

            <v-card-text>
              <average-count-transaction-chart
                :is-started="isStarted"
                :five-secsdataset="transactionCountIn5secsList"
                :ten-secsdataset="transactionCountIn10secsList"
                :thirty-secsdataset="transactionCountIn30secsList"
                :sixty-secsdataset="transactionCountIn60secsList"
                :scala="duration"
              />
            </v-card-text>
          </v-card>
        </v-col>

        <!-- TRANSACTION EFFECTIVE RATE -->
        <v-col :cols="cardColunmWidth">
          <v-card outlined class="rounded-lg" height="370">
            <v-card-title class="text-subtitle-1 font-weight-bold">
              {{ $t("effective_rate_t") }}
            </v-card-title>

            <v-card-text>
              <effective-rate-chart
                :is-started="isStarted"
                :dataset="effectiveRateTransactionDataset"
                :scala="duration"
              />
            </v-card-text>
          </v-card>
        </v-col>

        <!-- VARIATION TRANSACTION EFFECTIVE RATE -->
        <v-col :cols="cardColunmWidth">
          <v-card outlined class="rounded-lg" height="370">
            <v-card-title class="text-subtitle-1 font-weight-bold">
              {{ $t("variation_effective_rate_t") }}
            </v-card-title>

            <v-card-text>
              <variation-effective-rate-transaction
                :is-started="isStarted"
                :dataset="variationEffectiveRateTransactionDataset"
                :scala="duration"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div v-else>
      {{ $tc("loading") }}
      <v-progress-linear indeterminate class="mb-0" />
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import CountTransactionChart from './UsageCharts/CountTransactionChart.vue'
import RateTransactionChart from './UsageCharts/RateTransactionChart.vue'
import TransactionUsageRateVariation from './UsageCharts/TransactionUsageRateVariation.vue'
import EffectiveRateChart from './UsageCharts/EffectiveRateChart.vue'
import VariationEffectiveRateTransaction from './UsageCharts/VariationEffectiveRateTransaction.vue'
import AverageCountTransactionChart from './UsageCharts/AverageCountTransactionChart.vue'

export default {
  components: {
    CountTransactionChart,
    RateTransactionChart,
    TransactionUsageRateVariation,
    EffectiveRateChart,
    VariationEffectiveRateTransaction,
    AverageCountTransactionChart
  },
  created () {
    this.loadKeys()
  },
  mounted () {
    window.addEventListener('beforeunload', () => {
      window.scrollTo(0, 0)
    })

    if (this.parameterName !== undefined) {
      this.objectId = this.parameterName
      this.execute()
    }

    this.setIntervalId = setInterval(() => {
      if (this.startRequisition) {
        this.getStatsByObjectId()
      }
    }, this.requisitionInterval)
  },
  data () {
    return {
      setIntervalId: null,
      objects: null,
      objectStatistic: {},
      objectId: '',
      loading: false,
      isStarted: false,
      startRequisition: false,
      date: 0,

      statsColor: '#5ad45a',
      transactionColor: '#0bb4ff',

      dateLastTransaction: 0,
      countTransaction: 0,
      wctTransaction: 0,
      countTransactionDataset: [],
      rateTransactionDataset: [],
      rateDeltaList: [],
      effectiveRateTransactionDataset: [],
      effectiveRateDeltaList: [],
      variationEffectiveRateTransactionDataset: [],
      transactionUsageRateVariation: [],
      transactionCountIn5secsList: [],
      transactionCountIn10secsList: [],
      transactionCountIn30secsList: [],
      transactionCountIn60secsList: [],
      countTrasactionList: [],

      cardColorList: ['#F3F3F2', '#404040'],
      duration: 15000
    }
  },
  computed: {
    refreshIntervalOptions () {
      return [
        {
          name: this.$tc('n_second', 2, { n: 15 }),
          value: 15 * 1000
        },
        {
          name: this.$tc('minute', 1),
          value: 1 * 60 * 1000
        },
        {
          name: this.$tc('minute', 2, { n: 5 }),
          value: 5 * 60 * 1000
        },
        {
          name: this.$tc('hour', 1),
          value: 60 * 60 * 1000
        },
        {
          name: this.$tc('hour', 2, { n: 3 }),
          value: 3 * 60 * 60 * 1000
        },
        {
          name: this.$tc('hour', 2, { n: 6 }),
          value: 6 * 60 * 60 * 1000
        },
        {
          name: this.$tc('hour', 2, { n: 24 }),
          value: 24 * 60 * 60 * 1000
        }
      ]
    },
    requisitionInterval () {
      return this.duration / 75
    },
    parameterName () {
      return this.$route.params.objectId
    },
    cardColunmWidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 12
        case 'sm':
          return 12
        case 'md':
          return 6
        case 'lg':
        case 'xl':
          return 4
        default:
          return 4
      }
    },
    objectErrors () {
      const errors = []
      if (!this.$v.objectId.$dirty) return errors
      !this.$v.objectId.required &&
        errors.push(this.$t('$validation.required'))
      !this.$v.objectId.isExistingObject &&
        errors.push(this.$t('$validation.key_name_not_found'))
      !this.$v.objectId.isSingleObject &&
        errors.push(this.$t('$validation.is_not_single_key'))
      return errors
    },
    darkMode () {
      return this.$store.state.ui.darkModeEnabled
    },
    cardColor () {
      return this.darkMode ? this.cardColorList[1] : this.cardColorList[0]
    }
  },
  methods: {
    loadKeys () {
      this.$store.dispatch('keys/getListKeys').then((res) => {
        this.objects = res
      })
    },
    getStatsByObjectId () {
      const body = { obj: this.objectId }

      this.$store
        .dispatch('hsm/getObjectStatistic', {
          body
        })
        .then((res) => {
          const seconds = Math.round(new Date().getTime() / 1000)

          this.countTrasactionList.push({ seconds, count: res.count_t })
          if (this.countTrasactionList.length > 100000) {
            this.countTrasactionList.shift()
          }

          this.mountTransactionDataSet(res)
        })
        .catch((err) => {
          this.startRequisition = false
          this.isStarted = false
          clearInterval(this.setIntervalId)

          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    },
    mountTransactionDataSet (observability) {
      const now = new Date()
      this.date = now

      const startTransaction = observability.start_t / 1000000 // Convert difference from microseconds to seconds
      const lastTransaction = observability.last_t / 1000000 // Convert difference from microseconds to seconds
      const countTransaction = observability.count_t
      const swctTransaction = observability.swct_t

      const wct = new Date(swctTransaction * 1000)

      const lastTouch = this.calculateLastTouch(startTransaction, lastTransaction, swctTransaction)

      const intervalBetweenWtcAndNow = (now - wct) / 1000

      if (this.isStarted === true) {
        this.dateLastTransaction = lastTouch
        this.countTransaction = countTransaction
        this.wctTransaction = swctTransaction
      }

      this.countTransactionDataset.push({ x: now, y: countTransaction })

      if (this.countTransactionDataset.length > 100000) {
        this.countTransactionDataset.shift()
      }

      const rateTransaction = countTransaction / intervalBetweenWtcAndNow

      this.rateTransactionDataset.push({ x: now, y: rateTransaction.toFixed(2) })

      if (this.rateTransactionDataset.length > 100000) {
        this.rateTransactionDataset.shift()
      }

      this.rateDeltaList.push({
        rate: rateTransaction,
        interval: intervalBetweenWtcAndNow
      })

      if (this.rateDeltaList.length > 100000) {
        this.rateDeltaList.shift()
      }

      if (this.rateDeltaList.length >= 2) {
        const rateSubList = this.rateDeltaList.slice(-2)
        const deltaRate = rateSubList[1].rate - rateSubList[0].rate
        const deltaInterval = rateSubList[1].interval - rateSubList[0].interval
        const variation = deltaRate / deltaInterval
        this.transactionUsageRateVariation.push({ x: now, y: variation.toFixed(2) })

        if (this.transactionUsageRateVariation.length > 100000) {
          this.transactionUsageRateVariation.shift()
        }
      }

      const lastStartDiff = lastTransaction - startTransaction
      const effectiveRate = countTransaction / lastStartDiff

      this.effectiveRateTransactionDataset.push({ x: now, y: effectiveRate })
      if (this.effectiveRateTransactionDataset.length > 100000) {
        this.effectiveRateTransactionDataset.shift()
      }

      this.effectiveRateDeltaList.push({
        rate: effectiveRate,
        interval: intervalBetweenWtcAndNow
      })

      if (this.effectiveRateDeltaList.length > 100000) {
        this.effectiveRateDeltaList.shift()
      }

      if (this.effectiveRateDeltaList.length >= 2) {
        const rateSubList = this.effectiveRateDeltaList.slice(-2)
        const deltaRate = rateSubList[1].rate - rateSubList[0].rate
        const deltaInterval = rateSubList[1].interval - rateSubList[0].interval
        const variation = deltaRate / deltaInterval
        this.variationEffectiveRateTransactionDataset.push({ x: now, y: variation })

        if (this.variationEffectiveRateTransactionDataset.length > 100000) {
          this.variationEffectiveRateTransactionDataset.shift()
        }
      }

      const seconds = Math.round(new Date().getTime() / 1000)
      const firstInterval = 5
      const secondInterval = 10
      const thirdInterval = 30
      const fourthInterval = 60

      // First Interval
      const transactionAverage5secs = this.transactionIntervalAverageCalculator(countTransaction, seconds, firstInterval)
      this.transactionCountIn5secsList.push({ x: this.date, y: transactionAverage5secs })

      // Second Interval
      const transactionAverage10secs = this.transactionIntervalAverageCalculator(countTransaction, seconds, secondInterval)
      this.transactionCountIn10secsList.push({ x: this.date, y: transactionAverage10secs })

      // Third Interval
      const transactionAverage30secs = this.transactionIntervalAverageCalculator(countTransaction, seconds, thirdInterval)
      this.transactionCountIn30secsList.push({ x: this.date, y: transactionAverage30secs })

      // Fourth Interval
      const transactionAverage60secs = this.transactionIntervalAverageCalculator(countTransaction, seconds, fourthInterval)
      this.transactionCountIn60secsList.push({ x: this.date, y: transactionAverage60secs })
    },
    transactionIntervalAverageCalculator (currentCount, currentSeconds, interval) {
      const counterPassedSeconds = this.countTrasactionList.filter(item => {
        return item.seconds === currentSeconds - interval
      }).slice(-1)[0]?.count

      return (currentCount - counterPassedSeconds) / interval
    },
    calculateLastTouch (start, last, swct) {
      const diff = last - start
      const lastUse = swct + diff
      return new Date(lastUse * 1000)
    },
    execute () {
      this.scrollToElement()
      this.loading = true
      this.getStatsByObjectId()
      this.loading = false
      this.isStarted = true
      this.startRequisition = true
    },
    handlePause () {
      this.isStarted = false
    },
    clearView () {
      this.isStarted = false
      this.startRequisition = false
      this.objectId = ''
      this.objectStatistic = {}
      this.date = 0

      this.dateLastTransaction = 0
      this.countTransaction = 0
      this.wctTransaction = 0
      this.countTransactionDataset = []
      this.rateTransactionDataset = []
      this.rateDeltaList = []
      this.effectiveRateTransactionDataset = []
      this.effectiveRateDeltaList = []
      this.variationEffectiveRateTransactionDataset = []
      this.transactionUsageRateVariation = []
      this.transactionCountIn5secsList = []
      this.transactionCountIn10secsList = []
      this.transactionCountIn30secsList = []
      this.transactionCountIn60secsList = []
      this.countTrasactionList = []
    },
    deleteKeyPressed () {
      // mesmo que o clearView, porém sem resetar objectId
      this.isStarted = false
      this.startRequisition = false
      this.objectStatistic = {}
      this.date = 0

      this.dateLastTransaction = 0
      this.countTransaction = 0
      this.wctTransaction = 0
      this.countTransactionDataset = []
      this.rateTransactionDataset = []
      this.rateDeltaList = []
      this.effectiveRateTransactionDataset = []
      this.effectiveRateDeltaList = []
      this.variationEffectiveRateTransactionDataset = []
      this.transactionUsageRateVariation = []
      this.transactionCountIn5secsList = []
      this.transactionCountIn10secsList = []
      this.transactionCountIn30secsList = []
      this.transactionCountIn60secsList = []
      this.countTrasactionList = []
    },
    scrollToElement () {
      const targetElement = this.$refs.elementToScrollTo
      const topScroll = targetElement.offsetTop + 50
      window.scrollTo({
        top: topScroll,
        behavior: 'smooth'
      })
    }
  },
  validations () {
    this.loadKeys()
    const validation = {}

    const isExistingObject = (value) => {
      if (this.objects !== null) {
        let filteredObjects = 0
        if (value !== null) {
          filteredObjects = this.objects.filter(
            (object) => object.indexOf(value) > -1
          ).length
        }
        return filteredObjects > 0
      } else {
        return false
      }
    }

    const isSingleObject = (value) => {
      if (this.objects !== null) {
        let filteredObjects = 0
        if (value !== null) {
          filteredObjects = this.objects.filter(
            (object) => object.indexOf(value) > -1 && value === object
          ).length
        }
        return filteredObjects === 1
      } else {
        return false
      }
    }

    validation.objectId = {
      required,
      isExistingObject,
      isSingleObject
    }

    return validation
  },
  destroyed () {
    this.clearView()
    clearInterval(this.setIntervalId)
  }
}
</script>
